module.exports = __webpack_public_path__ + "img/bg_score_04.6f4f6b95.jpg";